/* system-cms-prefix start */
const prefix = '/cmsmanager'
/* system-cms-prefix change const prefix = '/cmsadmin' system-cms-prefix change */
/* system-cms-prefix end */

export default {
  // 组织列表
  organizeList: `${prefix}/orgs/list`,
  // 组织删除
  organize: `${prefix}/orgs`,
  // 组织管理-成员管理
  organizeListUsers: `${prefix}/orgs/list/users`,
  // 组织管理-编辑-树形结构
  organizeTree: `${prefix}/orgs/tree`,
  organizeTreeAll: `${prefix}/orgs/tree/noauth`,
  // 组织管理-编辑-树形结构
  organizeNameUnique: `${prefix}/orgs/orgname/unique`,
  organizeSort: `${prefix}/orgs/sort`,
  // 系统设置
  systemSetting: `${prefix}/config/global`,
  // 系统-角色列表
  sysRolePage: `${prefix}/roles/page`,
  // 系统-角色
  sysRoles: `${prefix}/roles`,
  // 系统-角色下拉列表
  sysRolesList: `${prefix}/roles/list`,
  // 角色添加成员
  rolesAddUsers: `${prefix}/roles/list/users`,
  // 账户安全设置
  safeSetting: `${prefix}/config/global`,
  // 云存储下拉列表
  ossList: `${prefix}/sysOss/list`,
  // FTP下拉列表
  ftpList: `${prefix}/ftp/list`,
  // 人员密级列表
  userSecretList: `${prefix}/userSecrets/page`,
  // 人员密级名称是否可用
  userSecretCheck: `${prefix}/userSecrets/name/unique`,
  // 人员密级详情
  userSecret: `${prefix}/userSecrets`,
  // 内容、附件密级列表
  sysSecretsList: `${prefix}/secrets/page`,
  // 内容、附件密级名称是否可用
  sysSecretsCheck: `${prefix}/secrets/name/unique`,
  // 内容、附件密级
  sysSecrets: `${prefix}/secrets`,
  // 内容、附件密级所有列表
  sysSecretsAll: `${prefix}/secrets/list`,
  // 用户列表分页
  sysUsersPage: `${prefix}/users/page`,
  // 用户列表-启用
  sysUsersOn: `${prefix}/users/on`,
  // 用户列表-禁用
  sysUsersOff: `${prefix}/users/off`,
  // 用户列表-操作
  sysUsers: `${prefix}/users`,
  // 用户-权限
  sysUsersDataPerm: `${prefix}/dataPerm`,
  // 文档栏目权限站点列表
  sysPermSite: `${prefix}/dataPerm/site`,
  // 用户列表-操作
  sysRolesListUsers: `${prefix}/roles/list/users`,
  // API-新增
  apis: `${prefix}/apis`,
  // API-列表
  apisList: `${prefix}/apis/page`,
  // API-验证
  apisUnique: `${prefix}/apis/path/unique`,
  // 菜单
  menus: `${prefix}/menus`,
  // 菜单-树
  menusList: `${prefix}/menus/tree`,
  // 菜单-显示
  menusShow: `${prefix}/menus/display`,
  // 菜单-隐藏
  menusHidden: `${prefix}/menus/hidden`,
  // 菜单-开启权限控制
  menusOpenAuth: `${prefix}/menus/openAuth`,
  // 菜单-关闭权限控制
  menusCloseAuth: `${prefix}/menus/closeAuth`,
  // 菜单-排序
  menusSort: `${prefix}/menus/sort`,
  // 菜单-权限列表
  menusPermission: `${prefix}/menus/getMenus`,
  // 菜单-验证唯一
  menusUnique: `${prefix}/menus/routes/unique`,
  // 菜单标识-验证唯一
  menusNameUnique: `${prefix}/menus/name/unique`,
  // 防火墙配置
  iptables: `${prefix}/iptables`,
  // FTP存储列表
  ftpStorageList: `${prefix}/ftp/page`,
  // 单个FTP存储信息更新
  ftpStorage: `${prefix}/ftp`,
  // 模型
  model: `${prefix}/model`,
  // 模型-列表
  modelList: `${prefix}/model/page`,
  // 模型-新增全站
  modelCreateAll: `${prefix}/model/wholeSite`,
  // 模型-新增本站
  modelCreateThis: `${prefix}/model/thisSite`,
  // 模型-是否启用
  modelEnable: `${prefix}/model/isEnable`,
  // 模型-添加模型字段信息
  modelItem: `${prefix}/modelItem`,
  // 模型-排序
  modelSort: `${prefix}/model/sort`,
  // 模型-会员详情
  modelMember: `${prefix}/model/member`,
  // 模型-是否可用
  modelUnique: `${prefix}/model/modelName/unique`,
  // FTP存储列表
  ossStorageList: `${prefix}/sysOss/page`,
  // 单个FTP存储信息更新
  ossStorage: `${prefix}/sysOss`,
  // 第三方登录配置
  thirdParty: `${prefix}/thirds`,
  // 资源空间-我的资源列表
  resourceUserPage: `${prefix}/resourceSpaceDatas/user/page`,
  // 资源空间-共享资源列表
  resourcePage: `${prefix}/resourceSpaceDatas/page`,
  // 资源空间-我的资源-树形
  resourceSpacesPage: `${prefix}/resourceSpaces/page`,
  // 资源空间-共享资源-树形
  resourceSpacesSharePage: `${prefix}/resourceSpaces/sharePage`,
  // 资源空间-资源名是否重复
  resourceSpaceDatasAliaUnique: `${prefix}/resourceSpaceDatas/alia/unique`,
  // 资源空间-资源空间名是否重复
  resourceSpaceDatasNameUnique: `${prefix}/resourceSpaces/name/unique`,
  // 资源空间-操作-修改/删除/添加
  resourceSpaces: `${prefix}/resourceSpaces`,
  // 资源空间-资源-操作-删除/新增/重命名/详情
  resourceSpaceDatas: `${prefix}/resourceSpaceDatas`,
  // 资源空间-移动
  resourceSpacesMove: `${prefix}/resourceSpaces/move`,
  // 资源空间-资源-移动
  resourceSpaceDatasShift: `${prefix}/resourceSpaceDatas/shift`,
  // 资源空间-资源-下载到本地
  resourceSpaceDatasDownload: `${prefix}/resourceSpaceDatas/download`,
  // 资源空间-共享
  resourceSpacesShare: `${prefix}/resourceSpaces/share`,
  // 资源空间-资源-共享
  resourceSpaceDatasShare: `${prefix}/resourceSpaceDatas/share`,
  // 资源空间-取消共享
  resourceSpacesUnShare: `${prefix}/resourceSpaces/unShare`,
  // 资源空间-资源-取消共享
  resourceSpaceDatasUnShare: `${prefix}/resourceSpaceDatas/unShare`,
  // 邮件服务器设置
  email: `${prefix}/email`,
  // 发送测试邮件
  emailTest: `${prefix}/email/calibration`,
  // 微信服务设置
  weiXin: `${prefix}/weChatSetUp`,
  // 用户 用户名-验证
  usersUsernameUnique: `${prefix}/users/username/unique`,
  // 用户 邮箱-验证
  usersMailUnique: `${prefix}/users/mail/unique`,
  // 用户 手机号-验证
  usersPhoneUnique: `${prefix}/users/phone/unique`,
  // 用户 密码格式-验证
  usersPwdUnique: `${prefix}/users/pwd/unique`,
  // 用户 重置密码
  usersPwd: `${prefix}/users/psw`,
  // 第三方平台(微信/微博)管理员列表
  usersThirdManagerUnique: `${prefix}/users/third/manager/page`,
  // 实时日志
  logsRealTime: `${prefix}/logs/realTime`,
  // 日志列表
  logspage: `${prefix}/logs/page`,
  // 告警列表
  logsAlarmPage: `${prefix}/logs/alarm/page`,
  // 日志策略
  logsConfigs: `${prefix}/logConfigs`,
  // 日志详情
  logs: `${prefix}/logs`,
  // 日志备份列表
  logBackupsPage: `${prefix}/logBackups/page`,
  // 日志备份列表
  logBackups: `${prefix}/logBackups`,
  // 新建备份
  logBackupsSave: `${prefix}/logBackups/save`,
  // 备份恢复
  logBackupsRestore: `${prefix}/logBackups/restore`,
  // 日志导出
  logExport: `${prefix}/logs/export`,
  // 日志统计操作结果
  logStatisticsResult: `${prefix}/log/statistics/result`,
  // 日志统计事件类型
  logStatisticsEventType: `${prefix}/log/statistics/eventType`,
  // 日志统计操作类型
  logStatisticsOperationType: `${prefix}/log/statistics/operationType`,
  // 日志统计用户名
  logStatisticsUsername: `${prefix}/log/statistics/username`,
  // 系统信息
  systeminfo: `${prefix}/systeminfo`,
  // 系统信息更改授权码
  systeminfoChange: `${prefix}/systeminfo/change`,
  // 查询区域层级列表
  systemAreaList: `${prefix}/area/list`,
  // 修改区域排序
  systemAreaSort: `${prefix}/area/sort`,
  // 编辑
  systemArea: `${prefix}/area`,
  // 校验区域编号
  systemAreaCodeUnique: `${prefix}/area/code/unique`,
  // 区域树结构
  systemAreaTree: `${prefix}/area/tree`,
  // 导出告警日志
  logsAlarmExport: `${prefix}/logs/alarm/export`,
  // 三员管理 - 获取详情
  safeManage: `${prefix}/safe/manage`,
  // 三员管理 - 审核操作
  auditOperate: `${prefix}/safe/manage/operate`,
  // 三员管理审核 - 列表
  auditManagePage: `${prefix}/safe/manage/operate/page`,
  // 三员管理日志 - 列表
  auditManageLogPage: `${prefix}/safe/manage/operate/log/page`,
  // 管理员列表分页
  usersSafeManagePage: `${prefix}/users/safe/manage/page`,
  // 数据备份
  // 新建备份
  systemDatabaseBackupNew: `${prefix}/databaseBackup/backup`,
  // 备份还原
  systemDatabaseBackupRecovery: `${prefix}/databaseBackup/recovery`,
  // 备份下载
  systemDatabaseBackupDownload: `${prefix}/databaseBackup/download`,
  // 备份列表
  systemDatabaseBackupPage: `${prefix}/databaseBackup/page`,
  // 备份删除
  systemDatabaseBackup: `${prefix}/databaseBackup`,
  // 用户列表-无分页
  systemUserslist: `${prefix}/users/list`,
  // 单点登录设置
  // 设置详情
  sso: `${prefix}/sso`,
  // 三员管理-提交验证
  safeManageCheck: `${prefix}/safe/manage/check/operating`,
  // 校验安全管理员用户权限
  safeManageCheckUser: `${prefix}/safe/manage/check/user/menu`,
  // 双因子-设置
  doubleElement: `${prefix}/config/element`,
  // 双因子-是否强制绑定手机验证
  doubleElementHasBind: `${prefix}/config/element/hasBind`,
  // 双因子-绑定手机验证码
  doubleElementSendBind: `${prefix}/config/element/sendBind`,
  // 双因子-提交绑定手机
  doubleElementBind: `${prefix}/config/element/bind`,
  // 双因子-判断是否开启
  doubleElementStatus: `${prefix}/config/element/status`,
  // 绩效管理-列表
  pfrulePage: `${prefix}/pfrule/page`,
  // 绩效管理-复制
  pfruleCopy: `${prefix}/pfrule/copy`,
  // 绩效管理-检查规则名称
  pfruleUniqueName: `${prefix}/pfrule/unique/name`,
  // 绩效管理-删除/详情/修改
  pfrule: `${prefix}/pfrule`,
  // 绩效管理-评分列表
  pfruleScorelist: `${prefix}/pfrule/scorelist`,
  // 绩效管理-查看绩效列表
  pfscorePage: `${prefix}/pfscore/page`,
  // 绩效管理-查看绩效列表导出
  pfscoreExcel: `${prefix}/pfscore/excel`,
  // 绩效管理-查看绩效详情
  pfscore: `${prefix}/pfscore`,
  // 绩效管理-查看数量评分查看明细
  pfscoreDetailsNumber: `${prefix}/pfscore/details/number`,
  // 绩效管理-查看访问量查看明细
  pfscoreDetailsViews: `${prefix}/pfscore/details/views`,
  // 绩效管理-查看点赞查看明细
  pfscoreDetailsLike: `${prefix}/pfscore/details/like`,
  // 绩效管理-查看评论查看明细
  pfscoreDetailsComment: `${prefix}/pfscore/details/comment`,
  // 绩效管理-时效性评分查看明细
  pfscoreDetailsTime: `${prefix}/pfscore/details/time`,
  // 用户密级设置-待设置列表
  usersecretNosetpage: `${prefix}/usersecret/nosetpage`,
  // 用户密级设置-已设置列表
  usersecretSetpage: `${prefix}/usersecret/setpage`,
  // 人员密级列表
  userSecretsList: `${prefix}/userSecrets/list`,
  // 用户密级设置-批量设置密级
  userSecretIds: `${prefix}/usersecret`,
  // 用户密级设置-用户日志
  reinsuranceUserPages: `${prefix}/reinsurance/user/page`,
  // 用户密级设置-校验用户菜单
  reinsuranceCheckMenus: `${prefix}/reinsurance/check/admin/menu`,
  // 分级保护-判断是否开启
  reinsuranceIsShow: `${prefix}/reinsurance/isShow`,
  // 分级保护-查询详情
  reinsurance: `${prefix}/reinsurance`,
  // 分级保护-校验用户菜单权限
  reinsuranceCheckMenu: `${prefix}/reinsurance/check/user/menu`,
  // 分级保护-设置安全员或审计员的人员分页列表
  reinsuranceUserPage: `${prefix}/users/reinsurance/page`,
  // 分级保护-校验重置内容是否完成
  reinsResult: `${prefix}/content/execute/result`,
  // 分级保护-重置内容密级
  resetSecret: `${prefix}/content/reset/secret`
}
